import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { useDepots } from "@/api/depots";
import { CreateDepotButton } from "./create-depot-button";

const statusColors = {
  ACTIVE: "bg-green-500",
  INACTIVE: "bg-gray-500",
  MAINTENANCE: "bg-yellow-500",
  DELETED: "bg-red-500",
};

export function DepotsTable() {
  const { data: depots, isLoading } = useDepots();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-start mb-4 gap-4">
        <CreateDepotButton />
      </div>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Depot</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Capacity</TableHead>
              <TableHead>Location</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {depots?.map((depot) => (
              <TableRow key={depot.id}>
                <TableCell>
                  <div>
                    <p className="font-medium">{depot.name}</p>
                    <p className="text-sm text-gray-500">
                      {depot.operatingHours?.length > 0
                        ? `${depot.operatingHours[0].open}-${depot.operatingHours[0].close}`
                        : "No operating hours specified"}
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  <Badge variant="secondary">
                    {depot.type.replace("_", " ")}
                  </Badge>
                </TableCell>
                <TableCell>
                  <Badge
                    className={`${statusColors[depot.status]} text-white`}
                    variant="secondary"
                  >
                    {depot.status.replace("_", " ")}
                  </Badge>
                </TableCell>
                <TableCell>
                  <div>
                    <p className="font-medium">
                      L: {depot.currentCapacity.large} / {depot.capacity.large}
                    </p>
                    <p className="font-medium">
                      M: {depot.currentCapacity.medium} /{" "}
                      {depot.capacity.medium}
                    </p>
                    <p className="font-medium">
                      S: {depot.currentCapacity.small} / {depot.capacity.small}
                    </p>
                    <p className="text-sm text-gray-500">
                      {(
                        ((depot.currentCapacity.large +
                          depot.currentCapacity.medium +
                          depot.currentCapacity.small) /
                          (depot.capacity.large +
                            depot.capacity.medium +
                            depot.capacity.small)) *
                        100
                      ).toFixed(1)}
                      % utilized
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  <div>
                    <p className="font-medium">
                      {depot.address.city}, {depot.address.province}
                    </p>
                    <p className="text-sm text-gray-500">
                      {depot.address.location.lat.toFixed(6)},{" "}
                      {depot.address.location.lng.toFixed(6)}
                    </p>
                    {depot.serviceRadius && (
                      <p className="text-sm text-gray-500">
                        {depot.serviceRadius}km radius
                      </p>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
